
































































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { ImportacaoDeNota } from '@/models/ImportacaoDeNota'
import { totaisDaImportacao } from '@/usecases/importacao-de-notas/importacaoHelpers'
import { primaryColor } from '@/plugins/vuetify'

/**
 * Etapa 3 — resumo e confirmação.
 * Ao confirmar, emite 'finalizar' com as flags; o container faz upload + finalizarImportacao.
 */
@Component
export default class EtapaResumo extends Vue {
	@Prop({ type: Object, default: null }) importacao!: ImportacaoDeNota | null
	@Prop({ type: Boolean, default: false }) finalizando!: boolean

	naoMovimentarEstoque = false
	naoAtualizarPreco = false

	created() {
		if (this.importacao) {
			this.naoMovimentarEstoque = !!this.importacao.naoDeveMovimentarEstoque
			this.naoAtualizarPreco = !!this.importacao.naoDeveAtualizarTabelaDePreco
		}
	}

	get corPrimaria(): string {
		return primaryColor()
	}

	get totais() {
		return totaisDaImportacao(this.importacao ? this.importacao.produtos : [])
	}

	formatarNumero(n: number): string {
		return new Intl.NumberFormat('pt-BR').format(n || 0)
	}

	formatarMoeda(n: number): string {
		return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n || 0)
	}

	confirmar() {
		this.$emit('finalizar', {
			naoDeveMovimentarEstoque: this.naoMovimentarEstoque,
			naoDeveAtualizarTabelaDePreco: this.naoAtualizarPreco,
		})
	}
}
